import { render, staticRenderFns } from "./FooterClientView.vue?vue&type=template&id=53623d9c&"
import script from "./FooterClientView.vue?vue&type=script&lang=js&"
export * from "./FooterClientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports